/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Win_Back_Paywall_Benefit_No_AdsInputs */

const en_win_back_paywall_benefit_no_ads = /** @type {(inputs: Win_Back_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Focus without Ads`)
};

const ar_win_back_paywall_benefit_no_ads = /** @type {(inputs: Win_Back_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تركيز بلا إعلانات`)
};

const de_win_back_paywall_benefit_no_ads = /** @type {(inputs: Win_Back_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konzentrieren ohne Werbung`)
};

const es_win_back_paywall_benefit_no_ads = /** @type {(inputs: Win_Back_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concentración sin anuncios`)
};

const fr_win_back_paywall_benefit_no_ads = /** @type {(inputs: Win_Back_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concentration sans publicité`)
};

const it_win_back_paywall_benefit_no_ads = /** @type {(inputs: Win_Back_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concentrazione senza pubblicità`)
};

const ja_win_back_paywall_benefit_no_ads = /** @type {(inputs: Win_Back_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`広告なしで集中`)
};

const ko_win_back_paywall_benefit_no_ads = /** @type {(inputs: Win_Back_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`광고 없이 집중`)
};

const pt_br_win_back_paywall_benefit_no_ads = /** @type {(inputs: Win_Back_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foco sem anúncios`)
};

const ru_win_back_paywall_benefit_no_ads = /** @type {(inputs: Win_Back_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фокусировка без рекламы`)
};

const th_win_back_paywall_benefit_no_ads = /** @type {(inputs: Win_Back_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โฟกัสโดยไม่มีโฆษณา`)
};

const tr_win_back_paywall_benefit_no_ads = /** @type {(inputs: Win_Back_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reklamsız odaklanma`)
};

const zh_cn_win_back_paywall_benefit_no_ads = /** @type {(inputs: Win_Back_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无广告专注体验`)
};

const zh_tw_win_back_paywall_benefit_no_ads = /** @type {(inputs: Win_Back_Paywall_Benefit_No_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無廣告專注體驗`)
};

/**
* | output |
* | --- |
* | "Focus without Ads" |
*
* @param {Win_Back_Paywall_Benefit_No_AdsInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const win_back_paywall_benefit_no_ads = /** @type {((inputs?: Win_Back_Paywall_Benefit_No_AdsInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Win_Back_Paywall_Benefit_No_AdsInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_win_back_paywall_benefit_no_ads(inputs)
	if (locale === "ar") return ar_win_back_paywall_benefit_no_ads(inputs)
	if (locale === "de") return de_win_back_paywall_benefit_no_ads(inputs)
	if (locale === "es") return es_win_back_paywall_benefit_no_ads(inputs)
	if (locale === "fr") return fr_win_back_paywall_benefit_no_ads(inputs)
	if (locale === "it") return it_win_back_paywall_benefit_no_ads(inputs)
	if (locale === "ja") return ja_win_back_paywall_benefit_no_ads(inputs)
	if (locale === "ko") return ko_win_back_paywall_benefit_no_ads(inputs)
	if (locale === "pt_br") return pt_br_win_back_paywall_benefit_no_ads(inputs)
	if (locale === "ru") return ru_win_back_paywall_benefit_no_ads(inputs)
	if (locale === "th") return th_win_back_paywall_benefit_no_ads(inputs)
	if (locale === "tr") return tr_win_back_paywall_benefit_no_ads(inputs)
	if (locale === "zh_cn") return zh_cn_win_back_paywall_benefit_no_ads(inputs)
	return zh_tw_win_back_paywall_benefit_no_ads(inputs)
});